import React, {useEffect, useState} from 'react';
import {ImeanHeader} from "../../components/Header/Header";
import {StickyNavigationHeader} from "../../components/Navigation/StickyNavigationHeader";
import {useTranslation} from "react-i18next";
import COIN_ICON from "../icons/coin-icon.png";
import XP_ICON from "../icons/xp-icon.png";
import AchievementCard from "../../components/Cards/AchievementCard";
import {message, Spin} from "antd";
import {fetchWrapper} from "../../helpers";
import AchievementStatusCard from "../../components/Cards/AchievementStatusCard";
import AchievementGainedBar from "../../components/Cards/AchievementGainedBar";
import {useNavigate} from "react-router-dom";

const baseUrl = `${process.env.REACT_APP_API_URL}`;

const AchievementsPage = () => {
	const {t} = useTranslation();
	const [myStats, setMyStats] = useState(undefined);
    const navigate = useNavigate();

	useEffect(() => {
		fetchWrapper.get(`${baseUrl}/achievements?v=f`)
				.then((data) => {
					if (data){
						setMyStats(data);
					}
				})
				.catch((error) => {
					message.error(t("achievements.fetchingError"));
					console.error(error);
				});
	}, []);

	return (
			<div className='pb-24'>
                <ImeanHeader initialDark={true}></ImeanHeader>
                <StickyNavigationHeader headerTitle={t('home.myAchievements')}
                                        onBackClick={() => navigate('/home')}></StickyNavigationHeader>

				{myStats ? (
						<>
							<div className='max-w-xl mx-auto mt-10 px-4 text-center'>
								<AchievementStatusCard status={myStats.status}/>

								<AchievementGainedBar level={myStats.level} xp={myStats.xp} coins={myStats.coins}/>

								<p className='text-sm text-gray-500 font-medium mt-10'>
									{t("achievements.unlockedCountAchievements", {
										opened: myStats.opened,
										count: myStats.count,
									})}
								</p>
							</div>

							<section className='mt-2.5 mx-auto max-w-xl px-4'>
								{myStats.achievements.map((achievement) => (
										<AchievementCard key={achievement.id} achievement={achievement}/>
								))}
							</section>
						</>
				): (
						<div className='w-full h-[40vh] flex justify-center items-end'>
							<Spin size="large" />
						</div>
				)}

			</div>
	);
};

export default AchievementsPage;